import Avatar from '../../pages/Avatar';
import Events from '../../pages/Events';
import EventsV3 from '../../pages/Events/v3';
import Home from '../../pages/Home';
import HomeV2 from '../../pages/Home/v2';
import HomeV3 from '../../pages/Home/v3';
import News from '../../pages/News';
import Progress from '../../pages/Progress';
import ProgressV3 from '../../pages/Progress/v3';
import ReaderV3 from '../../pages/Reader/v3';
import Reviews from '../../pages/Reviews';
import ReviewsV3 from '../../pages/Reviews/v3';

const privateRoutes = [
  {
    path: '/home',
    title: 'Home',
    component: () => <HomeV3 title="Home" />,
  },
  {
    path: '/v1-home',
    title: 'Home (Legacy)',
    component: () => <Home title="Home" />,
  },
  {
    path: '/v2-home',
    title: 'Home (V2)',
    component: () => <HomeV2 title="Home" />,
  },
  {
    path: '/avatar',
    title: 'Avatar',
    component: () => <Avatar />,
  },
  {
    path: '/progress',
    title: 'Progress',
    component: () => <ProgressV3 title="Progress" />,
    exact: true,
  },
  {
    path: '/v1-progress',
    title: 'Progress (Legacy)',
    component: () => <Progress title="Progress" />,
    exact: true,
  },
  {
    path: '/reviews',
    title: 'Reviews',
    component: () => <ReviewsV3 title="Reviews" />,
    exact: true,
  },
  {
    path: '/v1-reviews',
    title: 'Reviews (Legacy)',
    component: () => <Reviews title="Reviews" />,
    exact: true,
  },
  {
    path: '/reader',
    title: 'Reader',
    component: () => <ReaderV3 title="Reader" />,
    exact: true,
  },
  {
    path: '/v1-reader',
    title: 'Reader (Legacy)',
    component: () => <News title="Reader" />,
    exact: true,
  },
  {
    path: '/events',
    title: 'Events',
    component: () => <EventsV3 title="Events" />,
    exact: true,
  },
  {
    path: '/v1-events',
    title: 'Events (Legacy)',
    component: () => <Events title="Events" />,
    exact: true,
  },
];

export default privateRoutes;
